// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2-SLI","inner":"Form_inner__3vd8o","range":"Form_range__1bYkr","name":"Form_name__1l1br","actions":"Form_actions__3rDe2"};